import React from "react";
import { CheckIcon } from "lucide-react";
import { MockupSlot } from "./MockupSlot";
import { SectionHeading } from "./SectionHeading";
import { bonuses } from "../data/landing";
import { brandAssets } from "../data/offer";
export function BonusSection() {
  return <section id="bonus" className="bg-ivory" data-id="element-16" data-mp="1ye1p9s59alzu">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-17" data-mp="1yf2xzpysuwee">
        <SectionHeading title={<>
              Et pour aller encore plus loin…{" "}
              <span className="text-tangerine" data-id="element-19" data-mp="15pw1ewiwogvs">découvrez vos 4 bonus !</span>
            </>} subtitle="Des ressources complémentaires pour intégrer la foi dans les petits moments du quotidien." data-id="element-18" data-mp="1ao7ctboumzg4" />

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 md:mt-16 lg:grid-cols-4" data-id="element-20" data-mp="1eozkw1lziyat">
          {bonuses.map(bonus => <li key={bonus.label} className="flex flex-col rounded-[1.75rem] border-[4px] border-tangerine bg-white p-3.5" data-id="element-21" data-mp="qyn6q905c5bs">
              <div className="relative" data-id="element-22" data-mp="29suxan68nj0e">
                <MockupSlot src={bonus.cover} label={`Couverture — ${bonus.label}`} hint="Couverture bientôt disponible" className="aspect-[4/5] w-full" data-id="element-23" data-mp="29q0e0yyyo48k" />
                <img src={brandAssets.logo} alt="" className="absolute -right-2 -top-2 w-14 drop-shadow-md" data-id="element-24" data-mp="2ohiokh91x6kj" />
              </div>
              <div className="flex flex-1 flex-col px-1.5 pb-1.5 pt-5" data-id="element-25" data-mp="1vrsb8af8u8ph">
                <p className="w-fit rounded-full bg-tangerine px-3 pb-0.5 pt-1 font-display text-sm font-extrabold tracking-wide text-white" data-id="element-26" data-mp="1vu4y91zuz99e">
                  {bonus.label.toUpperCase()}
                </p>
                <h3 className="mt-3 font-display text-xl font-bold leading-tight text-royal lg:min-h-[5rem]" data-id="element-27" data-mp="3c6k38m8h9dy9">
                  {bonus.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-cocoa" data-id="element-28" data-mp="3h3tpjt0kl9hv">{bonus.text}</p>
                <p className="mt-5 flex items-center gap-2 font-display text-base font-bold text-leaf-deep" data-id="element-29" data-mp="1h1u6pwaf1k67">
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-leaf" data-id="element-30" data-mp="1c42h58x8ua56">
                    <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-31" data-mp="1q3aedw9uj86q" />
                  </span>
                  Inclus dans le Méga Pack
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}